// extracted by mini-css-extract-plugin
var _1 = "phone-input__KVoar";
var _2 = "phone-input-disabled__LGXYw";
export { _1 as "phoneInput", _2 as "phoneInputDisabled" }
